import api from "../../api/api"; // axios instance

export const getProducts = () => api.get("/Products");
export const getProductById = (id) => api.get(`/Products/${id}`);
export const createProduct = (data) => api.post("/Products", data);
export const updateProduct = (id, data) => api.put(`/Products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/Products/${id}`);
export const getSubCategories = () => api.get("/SubCategories");